import React from 'react'
import {Link} from 'react-router-dom'
import { Button } from '../components/Button'

export const PageNotFound = () => {
  return (
    <main>
      <section className='flex flex-col justify-center px-2'>
        <div className='flex flex-col items-center my-4'>
          <p className='text-7xl text-gray-700 font-bold my-10 dark:text-white'>404 - Oopsy!</p>
          <img src="https://images.pexels.com/photos/164446/pexels-photo-164446.jpeg?auto=compress&cs=tinysrgb&w=600"/>
        </div>
        <div className='flex justify-center my-4'>
          <Link to="/">
            <Button>Home</Button>
          </Link>
        </div>
      </section>
    </main>
  )
}
